import React, { forwardRef } from 'react';

const PricingPage = forwardRef((props, ref) => {
    return (
        <section ref={ref} className='py-24 bg-landing-white'>
            <div className='max-w-4xl mx-auto px-6'>
                {/* Header */}
                <div className='text-center'>
                    <span className='text-landing-blue-500 font-bold tracking-wide uppercase text-sm'>Pricing</span>
                    <h2 className='text-3xl md:text-4xl font-bold text-landing-slate-900 mt-2 mb-6'>
                        Enterprise-Tailored Pricing
                    </h2>
                    <p className='text-xl text-landing-slate-600 max-w-3xl mx-auto mb-8'>
                        Our pricing is designed to match the unique nature and requirements of your enterprise. 
                        We take into account the number of users, data volume, and specific use cases to ensure 
                        you receive the most appropriate and competitive pricing for the platform.
                    </p>
                    <p className='text-lg text-landing-slate-600 max-w-2xl mx-auto'>
                        We would be happy to provide you with a tailored proposal after understanding your 
                        specific requirements. Let's discuss how we can best serve your enterprise needs.
                    </p>
                </div>
            </div>
        </section>
    );
});

export default PricingPage;
